module.exports = __webpack_public_path__ + "img/電気回路_4_1_3.a6f40d99.png";